import $ from 'jquery';

const lang = document.documentElement.lang;
const roadmap = () => {
  $('g[data-emirate]').click((e) => {
    window.location.href = `${lang === 'ar' ? '/ar' : ''}/events-list?emirate=${$(e.currentTarget).attr('data-emirate')}`;
  });
};

export default () => {
  roadmap();
};
